import React from 'react'
import i18n from 'simple-react-i18n'
import { Icon } from '@mui/material'

const schemeAgencyIDHelpIcon = () => (<Icon icon='help' sx={ {
    paddingLeft: 5,
    fontSize: 14,
    position: 'relative',
    top: '-49px',
    left: '164px',
} } tooltip={i18n.schemeAgencyIDTooltyp}
/>)

export { schemeAgencyIDHelpIcon }